var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVideoHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 39,
    viewBox: "0 0 58 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.515625 7.56583C0.515625 3.60873 3.76444 0.4021 7.77051 0.4021H37.8366C41.8427 0.4021 45.0915 3.60874 45.0915 7.56583V11.0343L55.0975 3.59275C55.4736 3.31307 55.9774 3.26752 56.3986 3.47511C56.8198 3.68271 57.086 4.10775 57.086 4.57277V34.3072C57.086 34.7722 56.8198 35.1972 56.3986 35.4048C55.9774 35.6124 55.4736 35.5669 55.0975 35.2872L45.0915 27.8457V31.3141C45.0915 35.2713 41.8427 38.4778 37.8366 38.4778H7.77051C3.76445 38.4778 0.515625 35.2713 0.515625 31.3141V7.56583ZM45.0915 24.7749L54.6026 31.8483V7.03159L45.0915 14.1051V24.7749ZM7.77051 2.85543C5.13456 2.85543 2.99896 4.96503 2.99896 7.56583V31.3141C2.99896 33.915 5.13455 36.0245 7.77051 36.0245H37.8366C40.4726 36.0245 42.6081 33.915 42.6081 31.3141V7.56583C42.6081 4.96502 40.4726 2.85543 37.8366 2.85543H7.77051Z",
    fill: "#FF7816"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13C16 14.1046 15.1046 15 14 15C12.8954 15 12 14.1046 12 13C12 11.8954 12.8954 11 14 11C15.1046 11 16 11.8954 16 13Z",
    fill: "#FF7816"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.83432C6 7.71723 7.77926 6 9.97537 6H35.0246C37.2208 6 39 7.71722 39 9.83432V29.1657C39 31.2828 37.2208 33 35.0246 33H9.97537C7.77925 33 6 31.2828 6 29.1657V9.83432ZM18 13C18 15.2091 16.2091 17 14 17C11.7909 17 10 15.2091 10 13C10 10.7909 11.7909 9 14 9C16.2091 9 18 10.7909 18 13Z",
    fill: "#FF7816"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideoHome);
export default __webpack_public_path__ + "static/media/ic_video_home.75d7cb46366d21690c9549efa18e0c10.svg";
export { ForwardRef as ReactComponent };